const CreateWorkflowInstance = () => import("./CreateWorkflowInstance.vue");

export default {
  install(Vue) {
    Vue.component("fp-create-workflow-instance", CreateWorkflowInstance);
  },
};
